
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.25 2h-12A2.25 2.25 0 002 4.25v12a2.25 2.25 0 002.25 2.25h12a2.25 2.25 0 002.25-2.25v-12A2.25 2.25 0 0016.25 2zm-12 1.5h12a.75.75 0 01.75.75v12a.75.75 0 01-.75.75h-12a.75.75 0 01-.75-.75v-12a.75.75 0 01.75-.75z"}}),_c('path',{attrs:{"d":"M8.126 7.198A1.32 1.32 0 007.5 8.32v3.858a1.32 1.32 0 001.91 1.182l3.86-1.93a1.32 1.32 0 000-2.362l-3.86-1.93a1.32 1.32 0 00-1.284.059zM9 8.61l3.277 1.638L9 11.888V8.611z"}})])
          )
        }
      }
    